<template>
  <div>
    <div class="none">
      <div class="top">
        <div class="header">
          <div class="logo"><img src="../../../static/assets/images/maimai.png" alt=""></div>
          <div class="header_content">
            <li>首页</li>
            <li @click="toServerProductPage">内容精选</li>
            <li @click="toProductPage">商品精选</li>
            <li @click="toPostPage">社区精选</li>
            <li @click="toUs">关于我们</li>
            <li @click="toUs">联系我们</li>
            <li @click="toBusinessPermit">公司信息</li>
            <li @click="toServicePrivacy">隐私政策</li>

          </div>
        </div>
        <div class="content">
          <div class="imgPhone1"><img src="../../../static/assets/images/phone1.png" alt=""></div>
          <div class="right">
            <p class="title">麦麦酒市App</p>
            <p class="subtitle">茅台威士忌鉴定交易开创者</p>
            <div style=" margin-top: 100px; display: flex; flex-direction: column; align-items: center">
              <img src="../../../static/assets/images/5Oi7.png" alt="">
              <div id="iosclick"
                   style="display: flex; align-items: center; justify-content: center; font-size: 2rem;border: 2px solid;border-radius: 10px; margin-top: 20px; padding: 3px 0; width: 150px;">
                <img src="../../../static/assets/images/ios.png" style="width: 2rem;vertical-align: middle; margin-right: 15px;" alt=""> &nbsp;/ &nbsp;<img src="../../../static/assets/images/android.png"
                                                            style="width: 2rem;vertical-align: bottom; margin-left: 15px;" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main_1" id="about-section">
        <div class="main_content">
          <div class="left">
            <p style="font-size: 40px;">专业鉴别</p>
            <p style="font-size: 40px;">正品保障</p>
          </div>
          <div class="right">
            <img src="../../../static/assets/images/rice1.png" alt="">
          </div>
        </div>
      </div>

      <div class="nav">
        <div class="main_content">
          <div class="left">
            <p style="font-size: 40px;">自由买卖</p>
          </div>
          <div class="right">
            <img src="../../../static/assets/images/free1.png" alt="">
          </div>
        </div>
      </div>

      <div class="bottom" id="feature-section">
        <div class="row" style="text-align: center;">
          <p>关于我们</p>
          <div style="font-size: 18px; padding-bottom: 50px; width: 900px; margin:0 auto">
            麦麦酒市是集酒类买卖、鉴别查验、资讯动态社区于一体的新一代酒类收藏交易平台。通过我们专业团队的多道鉴别查验，以及海量的酒类专业咨询和信息，我们力求确保每一瓶酒的质量，让您可以更便利、放心的购买到值得消费、收藏的优质酒类商品。
          </div>
          <p>联系我们</p>
          <div style="display: inline-block;width: 33%">
            <div><img src="../../../static/assets/images/address.png" style="width: 20%;margin: 0 auto" alt=""></div>
            <div style="text-align: center;padding:20px 0;font-size: 15px"><span><br>北京朝阳区酒仙桥6号路7号楼18号楼<br></span></div>
          </div>
          <div style="display: inline-block;width: 33%">
            <div><img src="../../../static/assets/images/phonecode.png" style="width:25%;margin: 0 auto" alt=""></div>
            <div style="text-align: center;padding:20px 0;font-size: 15px"><span>联系电话：13311202160 <br>Email：maltmalt@163.com</span>
            </div>
          </div>
          <div style="display: inline-block;width: 33%">
            <div><img src="../../../static/assets/images/tunpai.png" style="width: 20%;margin: 0 auto" alt=""></div>
            <div style="text-align: center;padding:20px 0;font-size: 15px"><span><br>京ICP备19033870号-2</span></div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="none">
      <section id="banner-section">
        <header id="header-section" class="navbar-fixed-top">
          <nav class="navbar navbar-default">
            <div class="container">
              <div class="navbar-header">
                <a class="navbar-brand" style="margin-top: 3%" href="index.html">
                  <div class="logo">
                    <span id="navqq"><img src="../../../static/assets/images/maimai.png" alt="" style="width:20%;"></span>
                    <span id="navyq"><img src="../../../static/assets/images/icon.png" alt="" style="width:20%;"></span>
                  </div>
                </a>

              </div>
              <div style="width: 1220px; margin: 0 auto;">
                <ul style="font-size: 18px; margin-top: 30px;display: flex;">
                  <li>首页</li>
                  <li>商品精选</li>
                  <li>关于我们</li>
                  <li>联系我们</li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
        <div class="containerOne">
          <div class="row" style="position: relative">
            <div class="col-lg-2 col-sm-1"></div>
            <div class="col-lg-4 col-sm-5 location" style="margin-left: 100px;">
              <div class="banner-mobile">
                <img src="../../../static/assets/images/phone1.png" alt="banner-mobile" class="img-responsive" />
              </div>
            </div>
            <div class="col-lg-4 col-sm-5 locations" style="margin-top: -3%;">
              <div class="banner-cont">
                <h1>麦麦酒市</h1>
                <p>时光与酒的集市</p>
                <div class="row" style="margin-top:10%">
                  <div class="col-lg-4 col-sm-4 contentCode" style="text-align: center">
                    <img id="ios" src="../../../static/assets/images/5Oi7.png" style="" alt="">
                    <img id="android" src="../../../static/assets/images/5Oi7.png" style="display: none" alt="">
                  </div>
                  <div class="col-lg-4 col-sm-5 contentText" style="text-align: center">
                    <div id="iosclick" style="font-size: 2rem;border: 2px solid;border-radius: 10px;padding: 3px 0"><img src="../../../static/assets/images/ios.png" style="width: 2rem;vertical-align: top;margin-top: 0.2rem;" alt=""><b style="font-weight: 400;">iOS</b> </div>
                    <div id="androidclick" class="Android" style="font-size: 2rem;border: 2px solid;border-radius: 10px;margin-top: 5%;padding: 3px 0"><img src="../../../static/assets/images/android.png" style="width: 2rem;vertical-align: top;margin-top: 0.2rem;" alt=""><b style="font-weight: 400;">Android</b></div>
                  </div>
                  <div class="col-lg-4 col-sm-3"></div>
                </div>

              </div>
            </div>
            <div class="col-lg-2 col-sm-1"></div>
          </div>
        </div>
      </section>
      <section id="about-section">
        <div class="content">
          <div class="row text-content" style="padding-top: 8%;background: #e6e6e6;">
            <div class="col-lg-2 col-sm-2"></div>
            <div class="col-lg-3 col-sm-3 ">
              <p style="font-size: 40px;">专业鉴别</p>
              <p style="font-size: 40px;">正品保障</p>
            </div>
            <div class="col-lg-1 col-sm-1">
            </div>
            <div class="col-lg-5 col-sm-5">
              <div style="width:100%;margin: 0 auto">
                <img src="../../../static/assets/images/rice1.png" style="width: 65%" alt="">
              </div>
            </div>
            <div class="col-lg-1 col-sm-1"></div>
          </div>
          <div class="row text-content" style="padding-top: 8%;">
            <div class="col-lg-2 col-sm-2"></div>
            <div class="col-lg-3 col-sm-3">
              <p style="font-size: 40px;">自由买卖</p>
            </div>
            <div class="col-lg-1 col-sm-1">
            </div>
            <div class="col-lg-5 col-sm-5">
              <div style="width:100%;margin: 0 auto">
                <img src="../../../static/assets/images/free1.png" style="width: 65%" alt="">
              </div>
            </div>
            <div class="col-lg-1 col-sm-1"></div>
          </div>
        </div>
      </section>
      <section id="feature-section">
        <div class="content" style="background: #e6e6e6;padding-top: 5%">
          <h2 style="text-align: center;padding-top: 3%" >联系我们</h2>
          <div class="row" style="text-align: center;padding: 3% 0">
            <div class="col-lg-2 col-sm-0"></div>
            <div class="col-lg-8 col-sm-12">
              <div class="row" style="text-align: center;width: 100%">
                <div style="display: inline-block;width: 32%">
                  <div><img src="../../../static/assets/images/address.png" style="width: 20%;margin: 0 auto" alt=""></div>
                  <div style="text-align: center;padding:20px 0;font-size: 15px"><span><br>北京朝阳区酒仙桥6号路7号楼18号楼<br></span></div>
                </div>
                <div style="display: inline-block;width: 32%">
                  <div><img src="../../../static/assets/images/phonecode.png" style="width:25%;margin: 0 auto" alt=""></div>
                  <div style="text-align: center;padding:20px 0;font-size: 15px"><span>联系电话：13311202160 <br>Email：maltmalt@163.com</span></div>
                </div>
                <div style="display: inline-block;width: 32%">
                  <div><img src="../../../static/assets/images/tunpai.png" style="width: 20%;margin: 0 auto" alt=""></div>
                  <div style="text-align: center;padding:20px 0;font-size: 15px"><span><br>京ICP备19033870号-2</span></div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-sm-0"></div>
          </div>
        </div>
      </section>

    </div>-->
    <div id="showPhone">
      <div class="firstPart">
<!--        <div><img class="iconImg" src="../../../static/assets/images/icon.png" alt=""></div>-->
        <div class="title">
          <p>麦麦酒市App</p>
          <p>茅台威士忌鉴定交易开创者</p>
        </div>
        <div class="code">
          <div class="codeOne"><img src="../../../static/assets/images/qrcode.jpg" alt=""></div>
          <br><br>
          <button @click="jump()" style="background-color: unset; font-size: 20px;  border: 0px solid #e7e7e7; color: black;border-radius: 12px;">点击下载</button>

          <div class="codeContent">
            <div id="iosclick">
              <img src="../../../static/assets/images/ios.png" alt="">
              <b style="font-weight: 400;">iOS</b>
            </div>
            <div id="androidclick" class="Android">
              <img src="../../../static/assets/images/android.png" alt="">
              <b style="font-weight: 400;">Android</b>
            </div>
          </div>
        </div>
        <div class="phoneImage">
          <img style="width: 60%;" src="../../../static/assets/images/phone1.png" alt="">
        </div>
      </div>
      <div class="secondPart">
        <div class="secondTitle">
          <p>专业鉴别</p>
          <p>正品保障</p>
        </div>
        <div>
          <img style="width:100% ;" src="../../../static/assets/images/rice.png" alt="">
        </div>
      </div>
      <div class="threePart">
        <div class="threeTitle">
          <p>自由买卖</p>
        </div>
        <div>
          <img style="width:100% ;" src="../../../static/assets/images/free.png" alt="">
        </div>
      </div>
      <div class="fourPart">
        <div class="fourIcon"><img src="../../../static/assets/images/maimai.png" alt=""></div>
        <div class="fourP">
          <p>关于我们</p>
          <p>
            麦麦酒市是集酒类买卖、鉴别查验、资讯动态社区于一体的新一代酒类收藏交易平台。通过我们专业团队的多道鉴别查验，以及海量的酒类专业咨询和信息，我们力求确保每一瓶酒的质量，让您可以更便利、放心的购买到值得消费、收藏的优质酒类商品。</p>
        </div>
        <div class="fourP" style="text-align: center;padding-bottom: 20%;margin-top: 30%;">
          <div style="font-size: 18px; font-weight: 500;padding: 0">北京泊睿科技有限公司</div>
          <div style="font-size: 18px;letter-spacing: 0;padding: 0;">Beijing Breeze Techonologies Co., Ltd</div>
          <!--<div class="fourImg" style="margin-top: 4%;"><img src="../../../static/assets/images/address.png" alt="">北京
            朝阳区 酒仙桥 国际电子城7号楼18层
          </div>-->

          <div class="fourImg" style="margin-top: 4%; font-size: 16px"><img src="../../../static/assets/images/tunpai.png" alt="">京ICP备19033870号-2 | 增值电信业务经营许可证 京B2-20202099</div>
          <div class="fourImg" style="font-size: 16px"><img src="../../../static/assets/images/tunpai.png" alt="">食品经营许可证 JY11105112871705 </div>
          <div class="fourImg" style="font-size: 16px"><img src="../../../static/assets/images/phonecode.png" style="width: 6%;" alt="">13311202160
            | maltmalt@163.com
          </div>
          <div class="fourImg" style="font-size: 16px">
            <div style="text-align: center;font-size: 15px" @click="toBusinessPermit()">营业执照</div>
            <div style="text-align: center;font-size: 15px" @click="toServicePrivacy()">隐私政策</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

	$(document).ready(function () {

		$("#iosclick").click(function () {
			$("#ios").show();
			$("#android").hide();

		});
		$("#androidclick").click(function () {
			$("#android").show();
			$("#ios").hide();
		});
	})

	export default {
		name: "homePage",
		data() {
			return {}
		},
		methods: {
      jump(){
        window.location.href = "https://www.maltmalt.com/jump.html?invitationCode=h5malt"
      },
			toProductPage() {
				this.$router.push({
					name: "productPage"
				})
			},
			toPostPage() {
				this.$router.push({
					name: "postPage"
				})
			},
      toServerProductPage() {
        this.$router.push({
          name: "serverProductPage"
        })
      },
      toBusinessPermit(){
        window.open('https://www.maltmalt.com/src/files/htmlPage/businessPermit.html')
      },
      toServicePrivacy(){
        window.open('https://www.maltmalt.com/src/files/htmlPage/servicePrivacy.html')
      },

			toAbout() {
				document.getElementById("about-section").scrollIntoView({
					behavior: "smooth",
				});
			},
			toUs() {
				document.getElementById("feature-section").scrollIntoView({
					behavior: "smooth",
				});
			}
		}
	}
</script>

<style scoped lang="scss">
  .none {
    width: 100%;

    .top {
      width: 100%;
      background-image: url("../../../static/assets/images/back.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .header {
        width: 1220px;
        height: 100px;
        margin: auto;
        overflow: hidden;
        display: flex;

        .logo {
          width: 50px;
          height: 50px;
          margin-top: 25px;

          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }

        .header_content {
          height: 100px;
          margin-left: 250px;
          float: right;
          display: flex;
          align-items: center;
          justify-content: center;

          li {
            padding: 0 20px;
            font-size: 18px;
            color: #555;
            cursor: pointer;
          }
        }
      }

      .content {
        width: 1220px;
        margin: 100px auto 0;
        height: 600px;
        display: flex;
        justify-content: center;

        .imgPhone1 {
          height: 100%;

          img {
            display: block;
            height: auto;
            width: 420px;
          }
        }

        .right {
          margin-left: 50px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .title {
            font-size: 60px;
            font-weight: bolder;
          }

          .subtitle {
            font-size: 20px;
            margin-top: 20px;
          }

          img {
            width: 130px;
            height: auto;
            display: block;
          }
        }
      }
    }

    .main_1, .nav {
      width: 100%;
      padding-top: 150px;

      .main_content {
        display: flex;
        width: 1220px;
        margin: 0 auto;
        justify-content: center;
        align-items: center;

        .right {
          height: 100%;
          margin-left: 200px;

          img {
            display: block;
            height: auto;
            width: 420px;
          }
        }
      }
    }

    .main_1, .bottom {
      background: #e6e6e6;
    }

    .nav {
      background: #fff;
    }

    .bottom {
      padding-top: 70px;

      .row {
        width: 1220px;
        margin: 0 auto;

        p {
          font-size: 30px;
          padding: 25px 0;
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/home/homePage.vue